import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-zhengzhu",
  "use": "icon-zhengzhu-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-zhengzhu\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 64.2c-213.1 0-361.5 268.2-361.5 509 0 234.9 141.9 386.7 361.5 386.7s361.6-151.8 361.6-386.7c-0.1-240.8-148.5-509-361.6-509z m0 94.7c121.7 0 237.4 158.4 262 342.9-73.5-32.3-178.3-42.2-279 44.7-109.7 94.8-207.3 6.5-217.9-3.7-8.4-8.3-19.2-12.8-30.1-13.5 16.2-195.9 137.3-370.4 265-370.4z m0 706.2c-144.9 0-239.2-82.2-261.6-223.3 36.4 23.5 85.5 43.2 140.4 43.2 52.1 0 109.4-17.7 166.2-66.7 101.1-87.3 195.4-24.4 220.1-4.9C763.3 771.8 666.4 865.1 512 865.1z\" p-id=\"2721\" fill=\"#8a8a8a\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/zhengzhu.svg
// module id = M7mF
// module chunks = 22